import React from 'react';
import classNames from 'classnames';

const ns = `numeric-input`;

const NumericInput = ({
	onIncrement,
	onDecrement,
	className,
	disabled,
	...props
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<div className={rootClassnames}>
			<button
				type="button"
				disabled={disabled}
				className={`${ ns }__decrement`}
				aria-label="Decrease quantity"
				onClick={onDecrement}
			>
				<span>-</span>
			</button>
			<input
				disabled={disabled}
				type="number"
				inputMode="numeric"
				min="1"
				step="1"
				className={[`${ ns }__input`, className].join(' ')}
				{...props}
			/>
			<button
				type="button"
				disabled={disabled}
				className={`${ ns }__increment`}
				aria-label="Increase quantity"
				onClick={onIncrement}
			>
				<span>+</span>
			</button>
		</div>
	);
};

export default NumericInput;
